<template>
  <div class="container">
    <section id="editContent" class="columnContainer settingPage">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.more_features}}</h1>
        <div class="flexBox">
          <div class="flexInner">
            <Morningcall
              :locale="locale"
              :morningcall="features.morningcall" />
            <Parking
              :locale="locale"
              :parking="features.parking" />
          </div>
          <div class="flexInner">
            <Mobility
              :locale="locale"
              :mobility="features.mobility" />
          </div>
          <div class="flexInner"></div>
        </div>
      </div>
    </section>
    <div id="setContent">
      <div class="innerItem">
        <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
      </div>
    </div>
   </div>
</template>

<script>
import regExp from '@/common/regExp'
import Morningcall from '@/components/Features/Morningcall'
import Parking from '@/components/Features/Parking'
import Mobility from '@/components/Features/Mobility'

export default {
  name: 'Features',
  props: [
    'locale'
  ],
  components: {
    Morningcall,
    Parking,
    Mobility
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  data () {
    return {
      features: {
        morningcall: {
          active: false,
          repeat: [
            {
              id: 'everyday',
              active: true
            },
            {
              id: 'once',
              active: true
            }
          ],
          regist: false
        },
        parking: {
          active: false,
          carLimit: 2,
          regist: false,
          display: {
            area: true,
            entrance: true,
            depature: true
          },
          availableType: 'checkIn',
          setting: {
            checkIn: { updateParking: false, cancelParking: false },
            preArrive: { updateParking: false, cancelParking: false }
          }
        },
        mobility: {
          activePreset: true,
          preset: []
        }
      }
    }
  },
  methods: {
    async init () {
      this.$store.commit('onLoading', true)
      await this.$store.dispatch('features/getFeatures').then((res) => {
        if (res) {
          if (res.morningcall) {
            this.features.morningcall = {
              ...this.features.morningcall,
              ...res.morningcall
            }
          }
          if (res.parking) {
            const parking = { ...res.parking }
            delete parking.guestType
            this.features.parking = {
              ...this.features.parking,
              ...res.parking

            }
          }
        }
        this.$store.commit('onLoading', false)
      })
      this.$store.commit('onLoading', true)
      await this.$store.dispatch('features/getMobilityPreset').then((res) => {
        if (res) {
          this.features.mobility = {
            ...this.features.mobility,
            ...res
          }
        }
        this.$store.commit('onLoading', false)
      })
      this.$store.commit('onLoading', false)
    },
    // addMobilityPreset (data) {
    //   this.features.mobility.preset.push(data)
    // },
    saveMobilityPreset () {

    },
    async save () {
      const data = this.features
      const mobilityPresetData = data.mobility.preset.map(x => {
        return {
          presetid: x.id,
          presetName: x.name,
          lat: x.placeInfo.location.lat,
          lng: x.placeInfo.location.lng
        }
      })
      const parkingSettingData = data.parking.setting
      this.$store.commit('onLoading', true)
      try {
        await this.$store.dispatch('features/setFeatures', data)
        await this.$store.dispatch('features/setMobilityPreset', data.mobility)
        await this.$store.dispatch('features/setMobilityPresetData', mobilityPresetData)
        await this.$store.dispatch('features/setParkingSetting', parkingSettingData)
        alert(this.locale.complete_save)
        await this.init()
      } catch (ex) {
        console.log(ex)
      } finally {
        this.$store.commit('onLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
